function addOpenerToMenu(menuItems) {
    menuItems.forEach(function(menuItem) {
        // Kontrola, zda opener již existuje
        if (!menuItem.querySelector(':scope > .header-nav__opener')) {
            var opener = document.createElement('span');
            opener.className = 'header-nav__opener dropdown__btn';

            // Vložíme opener za první dítě (položku menu)
            menuItem.insertBefore(opener, menuItem.children[1]);
        }

        // Zpracujeme submenu pouze pokud existuje
        var subMenu = menuItem.querySelector(':scope > .sub-menu');
        if (subMenu) {
            var subMenuItems = subMenu.querySelectorAll(':scope > .menu-item-has-children');
            if (subMenuItems.length > 0) {
                addOpenerToMenu(subMenuItems);
            }
        }
    });
}

// Spustíme funkci pro všechny položky s dětmi v hlavním menu
addOpenerToMenu(document.querySelectorAll('.header-nav .menu-item-has-children'));
